'use client';

import { definePreview } from 'next-sanity/preview';
import type { QueryParams } from 'sanity';

import { SANITY_DATASET, SANITY_PROJECT_ID } from '../../config/sanity-env';
import { SANITY_PREVIEW_ACCESS_DENIED } from '../../constants/error';

function onPublicAccessOnly(): void {
  throw new Error(SANITY_PREVIEW_ACCESS_DENIED);
}

const useSanityPreview = definePreview({
  dataset: SANITY_DATASET,
  projectId: SANITY_PROJECT_ID,
  onPublicAccessOnly,
});

export type SanityPreview = <Result = unknown>(
  query: string,
  params?: QueryParams,
) => Result | null;

export const usePreview: SanityPreview = <Result = unknown>(
  query: string,
  params?: QueryParams,
): Result | null => {
  return useSanityPreview(null, query, params);
};
